import View from './View';

export { default as View } from './View';
export const useViewModel = (props) => props;
export const getPlayerAdCounterStyles = () => {};

export default View;
